import React, { useState, useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FirebaseContext } from "../context/FirebaseContext";
import {
  collection,
  getDocs,
  writeBatch,
  doc,
  deleteDoc,
} from "firebase/firestore";
import { getStorage, ref, deleteObject } from "firebase/storage";
import Typography from "@mui/material/Typography";
import MoreVertTwoToneIcon from "@mui/icons-material/MoreVertTwoTone";
import AlertDialog from "../components/AlertDialog.component";
import EnhancedTableHead from "../components/HeadTable.component";
import AlertBox from "../components/AlertBox.component";
import Spinner from "../components/Spinner.component";
import PropTypes from "prop-types";
import { alpha } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import TablePagination from "@mui/material/TablePagination";
import Toolbar from "@mui/material/Toolbar";
import Paper from "@mui/material/Paper";
import Checkbox from "@mui/material/Checkbox";
import Chip from "@mui/material/Chip";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import Button from "@mui/material/Button";
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import Snackbar from "@mui/material/Snackbar";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import Menu from "@mui/material/Menu";
import FilterListIcon from "@mui/icons-material/FilterList";
const headCells = [
  {
    id: "apercue",
    numeric: false,
    disablePadding: true,
    label: "Apercu",
  },
  {
    id: "nomProduct",
    numeric: false,
    disablePadding: false,
    label: "Nom",
  },
  {
    id: "priceProduct",
    numeric: true,
    disablePadding: false,
    label: "Prix (FCFA)",
  },
  {
    id: "descriptionProduct",
    numeric: false,
    disablePadding: false,
    label: "Description",
  },
  {
    id: "categorieProduct",
    numeric: false,
    disablePadding: false,
    label: "Categorie",
  },
  {
    id: "editProduct",
    numeric: false,
    disablePadding: false,
    label: "Editer",
  },
];

function EnhancedTableToolbar(props) {
  const { numSelected, datas, setOpenDialog, filter, setFilter, categories } =
    props;
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  function handleChange(e) {
    const value = e.target.value;
    if (value !== null) {
      setFilter(value);
    }
  }
  return (
    <Toolbar
      sx={{
        pl: { sm: 2 },
        pr: { xs: 1, sm: 1 },
        display: "flex",
        justifyContent: "space-between",
        width: "100%",
        ...(numSelected > 0 && {
          bgcolor: (theme) =>
            alpha(
              theme.palette.primary.main,
              theme.palette.action.activatedOpacity
            ),
        }),
      }}
    >
      {numSelected > 0 ? (
        <Typography
          sx={{ flex: "1 1 100%" }}
          color="inherit"
          variant="subtitle1"
          component="div"
          className="text-2xl max-md:!text-[1em]"
        >
          {numSelected} produit{numSelected > 1 ? "s" : ""} selectionné
          {numSelected > 1 ? "s" : ""}
        </Typography>
      ) : (
        <div className="flex flex-col space-y-1">
          <Typography
            sx={{ flex: "1 1 100%" }}
            variant="h6"
            id="tableTitle"
            component="div"
            className="text-2xl max-md:!text-[1.2em]"
          >
            Liste de produits enrégistré(s)
          </Typography>
          <Button
            variant="contained"
            onClick={(e) => {
              e.preventDefault();
              navigate("/admin/ajoutProduit");
            }}
            className="!hidden max-md:!block"
          >
            Ajouter un produit
          </Button>
        </div>
      )}

      {numSelected > 0 ? (
        <Tooltip title="Supprimer">
          <IconButton
            onClick={() => {
              setOpenDialog(true);
            }}
          >
            <DeleteIcon />
          </IconButton>
        </Tooltip>
      ) : (
        <div className="flex">
          {datas.length > 0 && (
            <Button
              variant="contained"
              onClick={(e) => {
                e.preventDefault();
                navigate("/admin/ajoutProduit");
              }}
              sx={{ mr: "10px" }}
              size="small"
              className="!block max-md:!hidden"
            >
              Ajouter un produit
            </Button>
          )}
          <Tooltip title="Filtre">
            <IconButton
              id="filtre-button"
              aria-controls={open ? "filtre-categorie" : undefined}
              aria-haspopup="true"
              aria-expanded={open ? "true" : undefined}
              onClick={handleClick}
            >
              <MoreVertTwoToneIcon />
            </IconButton>
          </Tooltip>
        </div>
      )}
      <Menu
        id="filtre-categorie"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "filtre-button",
        }}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <FormControl
          sx={{
            m: "0 10px",
          }}
        >
          <Button
            variant="contained"
            onClick={(e) => {
              e.preventDefault();
              navigate("/admin/gestionVente/categories");
            }}
            sx={{ display: "block", mb: "10px" }}
          >
            Ajouter un categorie
          </Button>
          <FormLabel id="filtre-categorie">
            <FilterListIcon />
            &ensp;Par categorie
          </FormLabel>
          <RadioGroup
            aria-labelledby="filtre-categorie-label"
            defaultValue={filter}
            name="filtre-categorie"
          >
            <FormControlLabel
              value="tout"
              control={<Radio />}
              label="Tout"
              onClick={handleChange}
            />
            {[...Object.entries(categories)].map((c) => (
              <FormControlLabel
                value={c[0]}
                key={c[0]}
                control={<Radio />}
                label={c[1].name}
                onClick={handleChange}
              />
            ))}
          </RadioGroup>
        </FormControl>
      </Menu>
    </Toolbar>
  );
}

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};

function GestionVente() {
  const { db } = useContext(FirebaseContext);
  const navigate = useNavigate();
  const categorieRef = collection(db, "categoriesProducts");
  const productsRef = collection(db, "products");

  const [selected, setSelected] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(4);
  const [categories, setCategories] = useState({});
  const [products, setProducts] = useState([]);
  const [visibleProducts, setVisibleProducts] = useState([]);
  const [productsWithLabel, setProductsWithLabel] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorType, setErrorType] = useState("");
  const [message, setMessage] = useState("");
  const [deleteAction, setDeleteAction] = useState(false);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState("tout");

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelected = visibleProducts.map((n) => n.id);
      setSelected(newSelected);
      return;
    }
    setSelected([]);
  };
  useEffect(() => {
    const fetchData = async () => {
      try {
        const snapshot = await getDocs(categorieRef);
        const categoryData = {};

        snapshot.docs.forEach((doc) => {
          categoryData[doc.id] = doc.data();
        });
        setCategories(categoryData);
      } catch (error) {
        console.error(error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const snapshot = await getDocs(productsRef).then((docs) => {
          setLoading(false);
          return docs;
        });
        const productData = [];
        const productDataLabel = {};

        snapshot.forEach((doc) => {
          productData.push({ id: doc.id, ...doc.data() });
          productDataLabel[doc.id] = doc.data();
        });
        setProducts(productData);
        setProductsWithLabel(productDataLabel);
      } catch (error) {
        console.error(error);
      }
    };

    fetchData();
  }, []);
  const handleClick = (event, id) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }
    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const isSelected = (id) => selected.indexOf(id) !== -1;

  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0
      ? Math.max(0, (1 + page) * rowsPerPage - visibleProducts.length)
      : 0;

  function deleteImages(imgRef) {
    return new Promise((resolve, reject) => {
      deleteObject(imgRef)
        .then(() => {
          resolve("delete image done");
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
  useEffect(() => {
    const bachDelete = async () => {
      if (deleteAction) {
        const batch = writeBatch(db);
        const storage = getStorage();
        const imgProdStorages = [];

        if (selected.length > 1) {
          selected.forEach((id) => {
            const docRef = doc(db, "products", id);
            const imgProdRef = ref(
              storage,
              productsWithLabel[id].pathStorageImage
            );
            imgProdStorages.push(deleteImages(imgProdRef));
            batch.delete(docRef);
          });
          Promise.all(imgProdStorages)
            .then((s) => {
              console.log(s);
            })
            .catch((e) => {
              console.log(e);
            });
          await batch
            .commit()
            .then(() => {
              onSuccessDeleted();
            })
            .catch((e) => {
              onFailDeleted(e);
            })
            .finally(() => {
              onFinishDeleted();
            });
        } else {
          const id = selected[0];
          const imgProdRef = ref(
            storage,
            productsWithLabel[id].pathStorageImage
          );
          deleteImages(imgProdRef)
            .then((r) => {
              //console.log(r);
            })
            .catch((e) => {
              console.log(e);
            });
          await deleteDoc(doc(db, "products", id))
            .then(() => {
              onSuccessDeleted();
            })
            .catch((e) => {
              onFailDeleted(e);
            })
            .finally(() => {
              onFinishDeleted();
            });
        }
      }
    };
    bachDelete();
  }, [deleteAction]);
  function onSuccessDeleted() {
    setErrorType("success");
    setMessage("Produit(s) Supprimer avec sucess!!");
    let dataRest = [...products];
    dataRest = dataRest.filter((product) => {
      return !selected.includes(product.id);
    });
    setProducts(dataRest);
    setSelected([]);
  }
  function onFailDeleted(e) {
    setErrorType("error");
    setMessage("Impossible de supprimer les produits !!");
    console.log(e);
  }
  function onFinishDeleted() {
    setOpenDialog(false);
    setDeleteAction(false);
    setTimeout(() => {
      setOpen(true);
    }, 500);
  }
  useEffect(() => {
    let datas = [...products];
    if (filter !== "tout") {
      datas = datas.filter((d) => {
        return d.categorieProd === filter;
      });
    }
    setVisibleProducts(datas);
  }, [filter, products]);

  if (loading) {
    return <Spinner />;
  }

  return (
    <>
      <h1 className="title">GESTION VENTE</h1>
      <hr />
      <Box sx={{ width: "100%" }}>
        <Paper sx={{ width: "100%", mb: 2 }}>
          <EnhancedTableToolbar
            numSelected={selected.length}
            datas={products}
            setOpenDialog={setOpenDialog}
            filter={filter}
            setFilter={setFilter}
            categories={categories}
          />
          <TableContainer>
            <Table
              sx={{ minWidth: 750 }}
              aria-labelledby="Liste produits"
              size={"medium"}
            >
              <EnhancedTableHead
                numSelected={selected.length}
                onSelectAllClick={handleSelectAllClick}
                rowCount={visibleProducts.length}
                headCells={headCells}
              />
              <TableBody>
                {(rowsPerPage > 0
                  ? visibleProducts.slice(
                      page * rowsPerPage,
                      page * rowsPerPage + rowsPerPage
                    )
                  : visibleProducts
                ).map((row, index) => {
                  const isItemSelected = isSelected(row.id);
                  const labelId = `enhanced-table-checkbox-${index}`;

                  return (
                    <TableRow
                      hover
                      role="checkbox"
                      aria-checked={isItemSelected}
                      tabIndex={-1}
                      key={row.id}
                      selected={isItemSelected}
                      sx={{ cursor: "pointer" }}
                    >
                      <TableCell padding="checkbox">
                        <Checkbox
                          color="primary"
                          checked={isItemSelected}
                          onClick={(event) => handleClick(event, row.id)}
                          inputProps={{
                            "aria-labelledby": labelId,
                          }}
                        />
                      </TableCell>
                      <TableCell
                        component="th"
                        id={labelId}
                        scope="row"
                        padding="none"
                        className="flex items-center"
                      >
                        <img
                          className="h-[60px] w-[60px] mt-1 object-cover object-top"
                          src={row.imageProd}
                          alt={row.nameProd}
                        />
                      </TableCell>
                      <TableCell align="left">{row.nameProd}</TableCell>
                      <TableCell align="right">{row.priceProd}</TableCell>
                      <TableCell align="left">
                        <p className="descProduct">{row.descriptionProd}</p>
                      </TableCell>
                      <TableCell align="left">
                        <Chip
                          label={categories[row.categorieProd]?.name}
                          size="small"
                          color="primary"
                          sx={{
                            color: categories[row.categorieProd]?.color,
                            bgcolor: categories[row.categorieProd]?.bg,
                          }}
                        />
                      </TableCell>
                      <TableCell align="left">
                        <IconButton>
                          <EditIcon
                            onClick={(e) => {
                              e.preventDefault();
                              navigate(
                                `/admin/gestionVente/produit/${row.nameProd}`,
                                {
                                  state: {
                                    id: row.id,
                                    pathImgID: row.pathStorageImage,
                                    img: row.imageProd,
                                    name: row.nameProd,
                                    price: row.priceProd,
                                    desc: row.descriptionProd,
                                    categorieID: row.categorieProd,
                                    categories: categories,
                                  },
                                }
                              );
                            }}
                          />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  );
                })}
                {emptyRows > 0 && (
                  <TableRow
                    style={{
                      height: 53 * emptyRows,
                    }}
                  >
                    <TableCell colSpan={6} />
                  </TableRow>
                )}
                {products.length === 0 && (
                  <TableRow>
                    <TableCell colSpan={headCells.length + 1} align="center">
                      Aucun Produit enregistré
                      <Button
                        variant="contained"
                        onClick={(e) => {
                          e.preventDefault();
                          navigate("/admin/ajoutProduit");
                        }}
                        sx={{ display: "block", m: "auto", mt: "10px" }}
                      >
                        Ajouter un produit
                      </Button>
                    </TableCell>
                  </TableRow>
                )}
                {visibleProducts.length === 0 && products.length !== 0 && (
                  <TableRow>
                    <TableCell colSpan={headCells.length + 1} align="center">
                      Aucun Produit enregistré pour la categorie '
                      {categories[filter]?.name}'
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            labelRowsPerPage="Produits par Page:"
            rowsPerPageOptions={[4, 10, 25]}
            component="div"
            count={visibleProducts.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Paper>
      </Box>
      <AlertDialog
        open={openDialog}
        setOpen={setOpenDialog}
        setAction={setDeleteAction}
        action={deleteAction}
        colorAction={"error"}
        labelAction={"Supprimer"}
        onCancel={() => setSelected([])}
      >
        <Alert severity="error">
          <AlertTitle>
            <strong>Attention !!!</strong>
          </AlertTitle>
          Souhaitez vous vraiment supprimer le{selected.length > 1 && "s"}{" "}
          produit{selected.length > 1 && "s"}: <br />
          <b>
            {selected.map((s, i) => (
              <span>
                {productsWithLabel[s]?.nameProd}
                {i + 1 === selected.length ? "" : ","}
              </span>
            ))}
          </b>
        </Alert>
      </AlertDialog>
      <Snackbar
        open={open}
        autoHideDuration={3000}
        onClose={() => setOpen(false)}
      >
        <AlertBox
          //onClose={handleClose}
          severity={errorType}
          sx={{ width: "100%" }}
        >
          {message}
        </AlertBox>
      </Snackbar>
    </>
  );
}

export default GestionVente;
